import { lazy } from 'react'

const BudgetComponent = lazy(async () => {
  const { Budget } = await import(/* webpackChunkName: "budget" */ './index')

  return {
    default: Budget
  }
})
const routes = [
  {
    path: '/budget',
    name: 'Budget',
    authenticated: true,
    render(props) {
      return <BudgetComponent {...props} />
    }
  }
]

export { routes }
